import {
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';
import { PageBlueprint } from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import { RiMegaphoneLine } from '@remixicon/react';

const releaseOverviewPage = PageBlueprint.make({
  params: {
    title: 'Releases',
    icon: <RiMegaphoneLine />,
    routeRef: convertLegacyRouteRef(rootRouteRef),
    path: '/release-overview',
    loader: () =>
      import('./components/ReleaseOverviewComponent').then(m =>
        compatWrapper(<m.ReleaseOverviewComponent />),
      ),
  },
});

export const releaseOverviewPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'release-overview',
  info: {
    packageJson: () => import('../package.json'),
  },
  extensions: [releaseOverviewPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
  }),
});
